import { useQuery } from "@tanstack/react-query";
import { PatientScreenerAnswerControllerApi } from "../../../services";
import { getConfigObject } from "../../../utils/utils";

interface Props {
  appointmentUuid: string;
  screenerType: string;
  xTENANTID?: string;
}

export const useGetPatientScreenersWithAssessment = (props: Props) => {
  const { appointmentUuid, screenerType, xTENANTID } = props;

  return useQuery({
    queryKey: [
      "patient-screeners-with-assessment",
      appointmentUuid,
      screenerType,
      xTENANTID,
    ],
    queryFn: async () =>
      await new PatientScreenerAnswerControllerApi(
        getConfigObject()
      ).getPatientScreenersWithAssessment(
        appointmentUuid,
        undefined,
        undefined,
        undefined,
        undefined,
        screenerType,
        xTENANTID
      ),
    enabled: !!appointmentUuid && !!screenerType,
  });
};
